import React from "react";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UI_RADIUS } from "../constants";
import { useUser } from "./UserContext";
import { PERMISSIONS } from "../permissions";

const CONFIG_SECTION_ROUTES = {
  features: "/config",
  branding: "/config/branding",
};

export default function ConfigSectionToggle({ activeSection, onBeforeNavigate }) {
  const navigate = useNavigate();
  const { can } = useUser() || {};
  const canManageBranding = Boolean(can?.(PERMISSIONS.CONFIG_BRANDING_MANAGE));

  const handleSectionChange = (_event, nextSection) => {
    if (!nextSection || nextSection === activeSection) {
      return;
    }
    const nextRoute = CONFIG_SECTION_ROUTES[nextSection];
    if (onBeforeNavigate && !onBeforeNavigate(nextRoute)) {
      return;
    }
    navigate(nextRoute);
  };

  return (
    <ToggleButtonGroup
      exclusive
      value={activeSection}
      onChange={handleSectionChange}
      aria-label="Configuration section"
      sx={{
        alignSelf: "flex-start",
        width: { xs: "100%", sm: "auto" },
        borderRadius: UI_RADIUS.button,
        bgcolor: "background.paper",
        border: 1,
        borderColor: "divider",
        p: 0.35,
        "& .MuiToggleButtonGroup-grouped": {
          border: 0,
          borderRadius: UI_RADIUS.button,
          minHeight: 38,
          px: 1.6,
          flex: { xs: 1, sm: "initial" },
          gap: 0.8,
          color: "text.secondary",
          textTransform: "none",
          fontWeight: 850,
          letterSpacing: 0,
          "&.Mui-selected": {
            bgcolor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              bgcolor: "primary.dark",
            },
          },
        },
      }}
    >
      <ToggleButton value="features" aria-label="Feature flags">
        <TuneOutlinedIcon sx={{ fontSize: 18 }} />
        Feature flags
      </ToggleButton>
      {canManageBranding && (
        <ToggleButton value="branding" aria-label="Branding">
          <PaletteOutlinedIcon sx={{ fontSize: 18 }} />
          Branding
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  );
}
